import {
  DocumentListSourceInfo,
  DocumentViewerListIdRequest,
} from '../../api/types/document.type';
import {SourceTypeCode} from '../../shared/constants';

export interface CreateDocumentViewerListRequestPayloadArgsForDocView {
  isInverse: boolean;
  isAllChildrenSelected: boolean;
  documentListMasterID: number;
  totalDocumentToView: number;
  sourceDetails: DocumentViewerListIdRequest['objSource']['sourceDetails'];
  docsToExclude: DocumentViewerListIdRequest['objSource']['sourceDetails'];
  columnFilters: DocumentViewerListIdRequest['objSource']['columnFilters'];
  sourceTypeCode?: DocumentViewerListIdRequest['objSource']['sourceTypeCode'];
  objSourceOverrides?: Partial<DocumentListSourceInfo>;
}

const getOptionalParameter = () => {
  return {
    optimizedCols: '',
    optimizedSelectFieldIDs: '',
    optimizedSelectFieldOrder: '',
    manualCols: '',
    manualSelectFieldIDs: '',
    manualSelectFieldOrder: '',
    selectFields: '',
    configuredCols: '',
    order: '',
    showCompletedDocOptimized: false,
    showCompletedDocManual: false,
    configuredShowCompletedDoc: false,
    selectFieldTemp: '',
    selectFieldDataTypeOptimized: [],
    selectFieldDataType: [],
    selectFieldDataTypeManual: [],
    redirectionType: 0,
    manualOrder: '',
  };
};

export const createDocumentViewerListRequestPayloadForDocView = ({
  documentListMasterID,
  sourceDetails,
  docsToExclude,
  columnFilters,
  isInverse,
  isAllChildrenSelected,
  totalDocumentToView,
  objSourceOverrides = {},
}: CreateDocumentViewerListRequestPayloadArgsForDocView): DocumentViewerListIdRequest => {
  const objSource: DocumentListSourceInfo = {
    // Required
    sourceTypeCode: SourceTypeCode.DOCUMENT,
    isInverse,
    documentListMasterID,
    sourceDetails,
    docsToExclude,
    isAllChildrenSelected,
    columnFilters,
    totalDocumentToView,
    isDocumentCount: false,
    // Optional
    userID: 0,
    securityGroupID: 0,
    roleID: 0,
    projectID: 0,
    assignmentSource: '',
    isMyAssignment: false,
    reviewerID: 0,
    isDefaultLoad: false,
    filters: [],
    sqlUnitParam: [],
    selectedAssignmentName: '',
    sessionDocViewId: 0,
    destinationTypeCode: '',
    sampleMethod: '',
    uniqueDocumentCount: 0,
    numberToAssign: 0,
    stR_SelectedSearchIds: [],
    destinationContextTypeCode: '',
    reportID: '',
    prevPageName: '',
    dataSetStatus: '',
    ...objSourceOverrides,
  } as never;

  return {
    objSource,
    docViewSessionObject: {
      sourceTypeCode: objSource.sourceTypeCode,
      docsForCodeSame: [],
      assignmentSource: '',
      sortconfiguration: getOptionalParameter(),
      assignmentSortDetails: [],
      backtoSrcSourceTypeCode: objSource.sourceTypeCode,
      xmlCompletedDocumentEditedCodingForm: '',
    } as never,
    sortConfigDocView: getOptionalParameter(),
    sessionDocMasterIds: [],
    sessionDocViewHistoryKey: [],
    sortConfigurationDocView: getOptionalParameter(),
    defaultAssName: '',
  };
};
